import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { MAINTENANCE_FAIL_MODE_PATH } from '../../../../config/paths';
import { postMaintenanceFailMode } from '../../../../actions/mechanical-maintenance';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import MaintenanceFailModeForm from './MaintenanceFailModeForm';
import { MAINTENANCE_WARNING_PRIORITY } from '../../../../config/constants';

const NewMaintenanceFailMode = ({
  breadcrumbs,
  dispatchPostMaintenanceFailMode,
}) => {
  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };

    newFormValues.categoryId =
      formValues.categoryId && formValues.categoryId.value;

    newFormValues.subCategoryId =
      formValues.subCategoryId && formValues.subCategoryId.value;

    newFormValues.priority = formValues.priority && formValues.priority.value;

    newFormValues.activityId =
      formValues.activityId && formValues.activityId.value;

    const maintenanceActivities =
      formValues.maintenanceFailModeActivityList || [];

    newFormValues.maintenanceFailModeActivityList = maintenanceActivities.map(
      (item) => ({
        activityId: item.value,
      }),
    );

    dispatchPostMaintenanceFailMode(newFormValues);
  };

  const content = (
    <MaintenanceFailModeForm
      onSubmit={onSubmit}
      initialValues={{
        priority: MAINTENANCE_WARNING_PRIORITY.MEDIUM,
      }}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo registro de Modo de Falla"
      subtitle="Crear nuevo registro de modo de falla"
      content={content}
    />
  );
};

NewMaintenanceFailMode.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostMaintenanceFailMode: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostMaintenanceFailMode: postMaintenanceFailMode,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Modos de Falla de Mantenimiento',
      href: MAINTENANCE_FAIL_MODE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewMaintenanceFailMode);
